import { dotPath, isNilOrEmpty } from 'ramdasauce'
import { getSrc } from 'gatsby-plugin-image'

import { Seo, RoadcastRainbow } from 'components/atoms'
import { TextSection } from 'components/molecules'
import { VimeoPlayer, VideoGrid, Layout } from 'components/organisms'

export const VideoView = ({ data, queueData }) => {
  const queueOrder = dotPath('queueOrder', queueData)
  const socialLinks = dotPath('socialLinks', data)

  const currentIndex = queueOrder.findIndex(
    (v) => v.urlSlug === data.urlSlug.current
  )
  const organized = [
    ...queueOrder.slice(currentIndex + 1),
    ...queueOrder.slice(0, currentIndex),
  ]

  const upNextVideos = organized.slice(0, 3)
  const moreVideos = organized.slice(3)

  const queue = { upNextVideos, gridLayout: moreVideos }

  return (
    <Layout>
      <Seo
        title={dotPath('interviewee', data)}
        pageImage={getSrc(data?.thumbnail)}
      />
      <VimeoPlayer data={data} queue={queue} />
      <RoadcastRainbow />
      {!isNilOrEmpty(moreVideos) && <VideoGrid data={queue} altHeader />}
      {!isNilOrEmpty(socialLinks) && <TextSection data={socialLinks} />}
    </Layout>
  )
}
